import clsx from "clsx"
import { createPortal } from "react-dom"

import useHorizontalScrollFade from "@hooks/useHorizontalScrollFade"
import useIsDesktop from "@hooks/useIsDesktop"

import { TabStack } from "@molecules"

import useNavTopBar from "@organisms/NavTopBar/NavTopBar.context"

import styles from "./NavTopBarTabs.module.scss"
import { NavTopBarTabsProps } from "./NavTopBarTabs.types"

export default function NavTopBarTabs(props: NavTopBarTabsProps) {
    const { children } = props

    const isDesktop = useIsDesktop()
    const { mobileTabsRef } = useNavTopBar()

    const { containerRef, scrollRef, isLeftClipped, isRightClipped } = useHorizontalScrollFade<HTMLDivElement>()

    const content = (
        <div
            ref={containerRef}
            className={clsx(styles.base, {
                [styles.leftContentClipped]: isLeftClipped,
                [styles.rightContentClipped]: isRightClipped,
            })}
        >
            <div className={styles.scroll} ref={scrollRef}>
                <TabStack variant="default" size="lg">
                    {children}
                </TabStack>
            </div>
        </div>
    )

    if (!isDesktop && mobileTabsRef) {
        return createPortal(content, mobileTabsRef)
    }

    return content
}
